import { testingToolsApi } from "./testingTools";

export const {
  useStartPtlTestMutation,
  useSimulatePressPTLButtonMutation,
  useGetInternalTestEventFeedQuery,
  usePostInternalTestEventMutation,
  useStopBinCircusMutation,
  useStartBinCircusMutation,
  useGetPortStatusForBinCircusQuery
} = testingToolsApi;
